module.exports = __webpack_public_path__ + "img/sy.ec939387.svg";